module.exports = __webpack_public_path__ + "65aeb4ef73ee85d65a8fe48ecaed132a.svg";